import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { stageProject } from 'src/app/web/interfaces/project/stages/stageProject';
import { DataTableDirective } from 'angular-datatables';
import { Subject, Subscription } from 'rxjs';
import { formatDate } from '@angular/common';
import { FormatterPeso, FormatterPesonNotDecimal, TableOneSearch } from 'src/app/web/util/formatDataTable';
import { ListAssigned } from 'src/app/web/interfaces/project/list/projectDetailsDto';
import { ApiServicePayment } from 'src/app/web/apis/ApiServicePayment';
import { ErrorService } from 'src/app/shared/services/errors.service';
import * as moment from 'moment';
import { Location } from '@angular/common';

export class listPay {

  id: number;
  title: string;
  pay_amount: string;
  listPaymentPlayIntoEndInfo:any

}

export class listPaylist {

  hes: string;
  facture: string;
  facture_date: string;


}
export class infoPay {

  hes: number;
  facture: number;
  facture_date: string;

}

export class infolistPay {

  id: number;
  title:string;
  money:string;
  amount:string;
  amount_percent:string;
  status:string;
  date_payment:string;
  idPay:string;
  hes:string;
  facture:string;
  facture_date:string;
  description:string;
  listProjectPlayIntoInfo:[
    id: number,
    hes: string,
    facture: number,
    facture_date: string
  ];



}
@Component({
  selector: 'app-pay-finance-taas',
  templateUrl: './pay-edit-finance.component.html',
  styleUrls: ['./pay-edit-finance.component.scss']
})
export class PayEditFinanceComponent implements OnInit {


  title = '';
  idProject: number;
  id: number;
  rescheduled_dateDate: string;
  scheduled_dateDate: string;
  real_dateDate: string;
  nameProject: string;
  paymentsform: FormGroup;
  projectStages: stageProject[] = [];
  developersTeam: ListAssigned[] = [];
  createPay: listPay;
  createPaylist: listPaylist;
  listAnexo: any[] = [];
  datos: infolistPay;
  listMoney: any[] = [];
  listPayInto: any[] = [];
  listPayInto2: infoPay;
  private apiService: ApiServicePayment;
  createPayForm: FormGroup;
  editPayForm: FormGroup;
  idSubscription: Subscription;
  items!: FormArray;
  active: boolean = false

  constructor(
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    private errorService:ErrorService,
    private location: Location

  ) {

    this.route.params.subscribe((params) => {
      this.id = params['idPay'];
      this.idProject = params['idProject'];
     
    });
  }

  ngOnInit(): void {
    this.active = false
    this.paymentsform = this.fb.group({
      items: new FormArray([])
    });



    this.createPayForm = this.fb.group({
      id: [0],
      title: [''],
      date_payment: [''],
      money: [''],
      pay_amount: [''],
    });

    this.editPayForm = this.fb.group({
      id: [0],
      title: [''],
      pay_amount: [''],
    });

    this.apiService = new ApiServicePayment(this.http);


    let rs = JSON.parse(localStorage.getItem("info-mtn"));
    rs.map((dato) => {
      if (dato.id == this.id) {
        this.datos = dato;
                    
        this.items = this.paymentsform.get("items") as FormArray
        

            if (dato.hes != 0) {

              let info = this.fb.group({
                idPay: dato.idPay,
                hes: dato.hes,
                facture: dato.facture,
                facture_date: moment(dato.facture_date).format("YYYY-MM-DD")
              });

              this.items.push(info)
            }

          

        // this.listPayInto.map((pay) => {
        //   
        // });


      }
    })

    if (this.datos.date_payment != null) {

        this.real_dateDate =   moment(this.datos.date_payment, 'DD-MM-YYYY').format("YYYY-MM-DD");

    } else {
      this.real_dateDate = "";

    }


    this.createPayForm.patchValue({
      id: this.datos.id,
      title: this.datos.title,
      date_payment: this.real_dateDate,
      money: this.datos.money,
      pay_amount: this.datos.amount
    });


  }

  goBack() {
    this.location.back();
  }

  nuevoCampo() {
    this.items = this.paymentsform.get("items") as FormArray
    let info = this.fb.group({
      hes: "",
      facture: "",
      facture_date: ""
    });

    this.items.push(info)

  }

  eliminarCampo(index) {
    this.items.removeAt(index)
  }

  transformName(name: string): string {
    let names = name.split('.');
    let nameString = "";
    for (let name of names) {
      nameString += name.charAt(0).toUpperCase() + name.slice(1) + " ";
    }
    return nameString;
  }

  fechaCambio(fecha: string) {
    let rescheduled_dateDay =
      fecha.split('-')[2];
    let rescheduled_dateMonth =
      fecha.split('-')[1];
    let rescheduled_dateYear =
      fecha.split('-')[0];
    let fecha_formato =
      rescheduled_dateDay +
      '/' +
      rescheduled_dateMonth +
      '/' +
      rescheduled_dateYear;
    return moment(fecha_formato).format("YYYY-MM-DD");
  }



  formSubmit(): void {
     this.spinner.show();

    if (this.createPayForm.value.title === '') {
      this.spinner.hide();

      Swal.fire({title:'Debe seleccionar un título',text: '',icon: 'error',heightAuto: false});
      return;
    }

    if (this.createPayForm.value.pay_amount === '') {
      this.spinner.hide();

      Swal.fire({title:'Debe rellenar un monto',text: '',icon: 'error',heightAuto: false});
      return;
    }



      this.createPay = new listPay();

      this.createPay.id = Number(this.id);
      this.createPay.title = this.createPayForm.value.title;
      this.createPay.pay_amount = this.createPayForm.value.pay_amount;
     
   
    this.createPay.listPaymentPlayIntoEndInfo = []
  
  
      for(let info of this.items.value){
        let payInfo = {
          idPay: info['idPay'],
          hes: info['hes'],
          facture:info['facture'],
          facture_date: moment(info['facture_date']).format("DD-MM-YYYY")
        }
        this.createPay.listPaymentPlayIntoEndInfo.push(payInfo)
      }
      

      this.apiService.putUpdate('payment-play-update', this.createPay)
        .subscribe({
          next: (data: any) => {

            if (data.code != null) {
              this.spinner.hide();
    
              Swal.fire( {
                title:  data.error,
                text: '',
                icon: 'error',
                heightAuto: false
              });
            } else {
              this.spinner.hide();
              Swal.fire({title: 'Se ha editado el pago correctamente' ,text: '',icon: 'success',heightAuto: false})
              .then(()=>{this.location.back()})
              //this.router.navigate(['/pdg/finance/pay/list']);
            }
          },
          error: (error) => {
            this.errorService.error(error);
          }
        });
  }

  transformAmount(event: any){
    
    let data =  event.target.value;

    var onlyNumbers =  data.toString().replace(/[^0-9,.]+/g, "");

    if( this.createPayForm.value.money == 'CLP'  || this.createPayForm.value.money == "Paraguayo"){
    
      let info = data.toString().replace(/[^0-9,.]+/g, "");
      info = info.replace('$','')
      info = info.split(".").join('')
      info = info.split(",").join('')
      onlyNumbers = info
      
      onlyNumbers = FormatterPesonNotDecimal().format(onlyNumbers)
    }else{
      
      let info = data.toString().replace(/[^0-9,.]+/g, "");
      info = info.replace('$','')
      info = info.split(".").join('')
      info = info.split(",").join('.')
      onlyNumbers = info
      
      onlyNumbers = FormatterPeso().format(onlyNumbers)
    }

    this.active = false;
    if(this.createPayForm.value.pay_amount != onlyNumbers){
      this.createPayForm.get("pay_amount").setValue(onlyNumbers);
    }
  }

  onKey(){
    this.active = true;
  }
}